import { productPriceStyles as styles } from "@insite/content-library/Components/ProductPrice";
import { css } from "styled-components";

styles.price = {
    unitOfMeasure: {
        unitOfMeasureText: {
            css: css`
                white-space: unset;
            `,
        },
    },
};

styles.secondaryPrice = {
    unitOfMeasure: {
        unitOfMeasureText: {
            css: css`
                white-space: unset;
            `,
        },
    },
}